import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import  { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';

import { HttpClient } from './http-client.service';

import { Resource } from '../../entities';

import { Settings } from '../../settings';
import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

@Injectable()
export class ResourceService {
  private readonly headers:Headers = new Headers({ 'Content-Type': 'application/json' });
  private readonly options:RequestOptions = new RequestOptions({ headers: this.headers });

  private static readonly resourceBaseUrl:string = `${Settings.apiUrl}/v1/Resources`;

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getResources(): Promise<Resource[]> {

    let oDataBuilder: ODataBuilder = new ODataBuilder(ResourceService.resourceBaseUrl);

    oDataBuilder
      .expand("ResourceCategory")
      .orderBy("ResourceCategory/SortOrder")
      .orderBy("SortOrder");

    let resourceUrl: string = oDataBuilder.toString();

    return this.http.get(resourceUrl)
      .toPromise()
      .then(response => response.json().value);
  }

  getResourceCountByResourceCategoryId(resourceCategoryId: string): Promise<number> {
    let oDataBuilder: ODataBuilder = new ODataBuilder(ResourceService.resourceBaseUrl);

    let resourceUrl:string = `${ResourceService.resourceBaseUrl}/?$filter=ResourceCategoryId eq ${resourceCategoryId}&$top=0&$count=true`;

    return this.http.get(resourceUrl)
      .toPromise()
      .then(response => {
        return response.json()['@odata.count'];
      });
  }

  createResource(resource: Resource): Promise<Resource> {
    let resourceUrl: string = `${Settings.apiUrl}/v1/Resources`;
    
    // must remove - breaks deserialization on the server when trying to convert empty string to Guid 
    delete resource.ResourceId;

    return this.http.post(resourceUrl, JSON.stringify(resource), this.options)
      .toPromise()
      .then(response => {
        return response.json();
      });
  }

  patchResource(resource: Resource): Promise<null> {

    let resourceUrl: string = `${Settings.apiUrl}/v1/Resources(${resource.ResourceId})`;

    return this.http.patch(resourceUrl, JSON.stringify(resource), this.options)
      .toPromise()
      .then(response => response);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/resource.service.ts